/**
 * @generated SignedSource<<d6c73eb25213769f09e3dbe434be746f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewTitleBlock = {
  content: string;
};
export type TitleEditCreateMutation$variables = {
  block: NewTitleBlock;
  index: number;
  realm: string;
};
export type TitleEditCreateMutation$data = {
  readonly addTitleBlock: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentManageRealmData">;
  };
};
export type TitleEditCreateMutation = {
  response: TitleEditCreateMutation$data;
  variables: TitleEditCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "index"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "realm"
},
v3 = [
  {
    "kind": "Variable",
    "name": "block",
    "variableName": "block"
  },
  {
    "kind": "Variable",
    "name": "index",
    "variableName": "index"
  },
  {
    "kind": "Variable",
    "name": "realm",
    "variableName": "realm"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "content",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metadata",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creators",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audioOnly",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v10/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Series",
      "kind": "LinkedField",
      "name": "series",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncedEventData",
      "kind": "LinkedField",
      "name": "syncedData",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AuthorizedEvent",
  "abstractKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dummy",
    "storageKey": null
  }
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "NotAllowed",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showTitle",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMetadata",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "layout",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TitleEditCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "addTitleBlock",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContentManageRealmData"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TitleEditCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "addTitleBlock",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMainRoot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Realm",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "blocks",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isBlock"
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "TitleBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "TextBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Series",
                    "kind": "LinkedField",
                    "name": "series",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entries",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/)
                ],
                "type": "SeriesBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v24/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Series",
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SyncedEventData",
                            "kind": "LinkedField",
                            "name": "syncedData",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "updated",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPassword",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuthorizedEventData",
                            "kind": "LinkedField",
                            "name": "authorizedData",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Track",
                                "kind": "LinkedField",
                                "name": "tracks",
                                "plural": true,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flavor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mimetype",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "resolution",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isMaster",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Caption",
                                "kind": "LinkedField",
                                "name": "captions",
                                "plural": true,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lang",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Segment",
                                "kind": "LinkedField",
                                "name": "segments",
                                "plural": true,
                                "selections": [
                                  (v30/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AuthorizedEvent",
                        "abstractKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showLink",
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "type": "VideoBlock",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "playlist",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v24/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creator",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v22/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "Missing",
                                "abstractKey": null
                              },
                              (v24/*: any*/),
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AuthorizedPlaylist",
                        "abstractKey": null
                      },
                      (v25/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isPlaylist"
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/)
                ],
                "type": "PlaylistBlock",
                "abstractKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editMode",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nameSource",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "block",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "RealmNameFromBlock",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9b5798a8cda272876eec53305949ff48",
    "id": null,
    "metadata": {},
    "name": "TitleEditCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TitleEditCreateMutation(\n  $realm: ID!\n  $index: Int!\n  $block: NewTitleBlock!\n) {\n  addTitleBlock(realm: $realm, index: $index, block: $block) {\n    ...ContentManageRealmData\n    id\n  }\n}\n\nfragment AddButtonsRealmData on Realm {\n  id\n}\n\nfragment BlockRealmData on Realm {\n  id\n  ...BlocksRealmData\n  ...EditButtonsRealmData\n  ...EditModeRealmData\n  blocks {\n    __typename\n    id\n    ...BlocksBlockData\n  }\n}\n\nfragment BlocksBlockData on Block {\n  __isBlock: __typename\n  id\n  __typename\n  ... on TitleBlock {\n    ...TitleBlockData\n  }\n  ... on TextBlock {\n    ...TextBlockData\n  }\n  ... on SeriesBlock {\n    ...SeriesBlockData\n  }\n  ... on VideoBlock {\n    ...VideoBlockData\n  }\n  ... on PlaylistBlock {\n    ...PlaylistBlockData\n  }\n}\n\nfragment BlocksRealmData on Realm {\n  path\n}\n\nfragment ContentManageRealmData on Realm {\n  name\n  path\n  isMainRoot\n  ancestors {\n    name\n    path\n    id\n  }\n  ...BlockRealmData\n  ...AddButtonsRealmData\n  blocks {\n    __typename\n    id\n  }\n}\n\nfragment EditButtonsRealmData on Realm {\n  ...MoveButtonsData\n  blocks {\n    __typename\n    ...RemoveButtonData\n    id\n  }\n  nameSource {\n    __typename\n    ... on RealmNameFromBlock {\n      block {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment EditModeFormRealmData on Realm {\n  id\n  blocks {\n    __typename\n    id\n  }\n}\n\nfragment EditModeRealmData on Realm {\n  blocks {\n    id\n    __typename\n    ... on TitleBlock {\n      ...TitleEditModeBlockData\n    }\n    ... on TextBlock {\n      ...TextEditModeBlockData\n    }\n    ... on SeriesBlock {\n      ...SeriesEditModeBlockData\n    }\n    ... on VideoBlock {\n      ...VideoEditModeBlockData\n    }\n    ... on PlaylistBlock {\n      ...PlaylistEditModeBlockData\n    }\n  }\n  ...EditModeFormRealmData\n}\n\nfragment MoveButtonsData on Realm {\n  id\n  blocks {\n    __typename\n    id\n  }\n}\n\nfragment PlaylistBlockData on PlaylistBlock {\n  playlist {\n    __typename\n    ...PlaylistBlockPlaylistData\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  showTitle\n  showMetadata\n  order\n  layout\n}\n\nfragment PlaylistBlockPlaylistData on Playlist {\n  __isPlaylist: __typename\n  __typename\n  ... on NotAllowed {\n    dummy\n  }\n  ... on AuthorizedPlaylist {\n    id\n    title\n    description\n    creator\n    canWrite\n    entries {\n      __typename\n      ... on AuthorizedEvent {\n        id\n        ...VideoListEventData\n      }\n      ... on Missing {\n        dummy\n      }\n      ... on NotAllowed {\n        dummy\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment PlaylistEditModeBlockData on PlaylistBlock {\n  playlist {\n    __typename\n    ... on NotAllowed {\n      dummy\n    }\n    ... on AuthorizedPlaylist {\n      id\n      opencastId\n      title\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  showTitle\n  showMetadata\n  order\n  layout\n}\n\nfragment RemoveButtonData on Block {\n  __isBlock: __typename\n  id\n}\n\nfragment SeriesBlockData on SeriesBlock {\n  series {\n    ...SeriesBlockSeriesData\n    id\n  }\n  showTitle\n  showMetadata\n  order\n  layout\n}\n\nfragment SeriesBlockSeriesData on Series {\n  id\n  title\n  created\n  description\n  state\n  metadata\n  canWrite\n  entries {\n    __typename\n    ... on AuthorizedEvent {\n      id\n      ...VideoListEventData\n    }\n    ... on NotAllowed {\n      dummy\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment SeriesEditModeBlockData on SeriesBlock {\n  series {\n    id\n    opencastId\n    title\n    state\n    description\n  }\n  showTitle\n  showMetadata\n  order\n  layout\n}\n\nfragment TextBlockData on TextBlock {\n  content\n}\n\nfragment TextEditModeBlockData on TextBlock {\n  content\n}\n\nfragment TitleBlockData on TitleBlock {\n  content\n}\n\nfragment TitleEditModeBlockData on TitleBlock {\n  content\n}\n\nfragment VideoBlockData on VideoBlock {\n  event {\n    __typename\n    ... on NotAllowed {\n      dummy\n    }\n    ... on AuthorizedEvent {\n      id\n      title\n      isLive\n      opencastId\n      created\n      creators\n      metadata\n      description\n      canWrite\n      hasPassword\n      series {\n        title\n        id\n        opencastId\n      }\n      syncedData {\n        duration\n        updated\n        startTime\n        endTime\n        thumbnail\n      }\n      ...VideoPageAuthorizedData\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  showTitle\n  showLink\n  showMetadata\n}\n\nfragment VideoEditModeBlockData on VideoBlock {\n  event {\n    __typename\n    ... on NotAllowed {\n      dummy\n    }\n    ... on AuthorizedEvent {\n      id\n      title\n      series {\n        id\n        title\n      }\n      created\n      isLive\n      creators\n      description\n      syncedData {\n        thumbnail\n        duration\n        startTime\n        endTime\n        audioOnly\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  showTitle\n  showLink\n  showMetadata\n}\n\nfragment VideoListEventData on AuthorizedEvent {\n  id\n  title\n  created\n  creators\n  isLive\n  description\n  series {\n    title\n    id\n  }\n  syncedData {\n    thumbnail\n    duration\n    startTime\n    endTime\n    audioOnly\n  }\n}\n\nfragment VideoPageAuthorizedData on AuthorizedEvent {\n  authorizedData {\n    tracks {\n      uri\n      flavor\n      mimetype\n      resolution\n      isMaster\n    }\n    captions {\n      uri\n      lang\n    }\n    segments {\n      uri\n      startTime\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "52a5a226671a5a8cfb14ca28b2870d3d";

export default node;
